import * as swiperjs from './swiperjs';
import * as modal from './modal';

// 初期設定
$(function () {

    // swiper.js　イメージキャンバスの高さ設定
    setPhotobox_height();
    $(window).on('resize', function () {
        setPhotobox_height();
    });
    /*
    setTimeout(function () {
        setPhotobox_height();
    }, 1000);*/

    // スライドにデフォルト（インデックス0番）値を設定
    insertParam_for_Slide($('.image_container').eq(0));

    // SmartPhotoライブラリ
    /*
    window.mySmartPhoto = new SmartPhoto(".slide_img_link", {
        resizeStyle: 'fit',
        arrows: false,
        nav: false,
        useHistoryApi: false,
    });*/

    // オリジナルデータダウンロードボタン表示非表示
    originalDataDLbtnToggle();
});

function setPhotobox_height() {
    $('#photobox').height(window.innerHeight);
    $('.swiper-slide').height(window.innerHeight - 140);
}

// ボタンクリック系
$(function () {
    
    // スライド閉じるボタン
    $('.photobox_close_btn').on("click", function () {
        modal.startScroll();
        $('#image_list').css({
            'opacity': '1',
            'pointer-events': 'auto'
        });
        $('#photobox').css('top', '100vh');
        $('#photobox').css('opacity', '0');
    });

    // スライドのチェックボックスをクリックしたら
    $('.checkbox_btn_photobox').on("click", function () {
        
        // checkbox　トグル
        let checkbox_elem = $('input:checkbox[name="selectimg"]').eq(swiper.realIndex);
        if (checkbox_elem.prop('checked')) {
            checkbox_elem.prop('checked', false);
        } else {
            checkbox_elem.prop('checked', true);
        }

        // チェック状況反映
        onChangeCheckbox();

        // チェックボックスの同期へ
        syncCheckbox(swiper.realIndex);
    });
    
    // 削除ボタン（one）
    $('#deleteButton_one').on("click", function () {

        let uuid_list = [];

        // 表示されている写真のuuidを取得
        uuid_list.push($('.image_container').eq(swiper.realIndex).attr('id'));

        Swal.fire({
            title: 'この写真のみを削除します',
            text: "削除すると元に戻せません",
            showCancelButton: true,
            confirmButtonText: '削除',
            cancelButtonText: 'キャンセル',
        }).then((result) => {
            if (result.isConfirmed) {
                delImage_one(uuid_list);
            }
        });
    });

    /////////////////////////////////////////////////戻るボタン制御
    // 戻るを無効（nullを履歴に追加）
    history.pushState(null, null, null);
    
    // 「戻る」ボタンが押された時
    $(window).on('popstate', function () {

        // imageModalを閉じる
        if ($('.image_modal').hasClass('image_modal_active')) {
            // 戻るを無効（nullを履歴に追加）
            history.pushState(null, null, null);

            $('.image_modal').removeClass('image_modal_active');
        } else {
            // スライドを閉じる
            if ($('#photobox').css('opacity') === '1') {
                // 戻るを無効（nullを履歴に追加）
                history.pushState(null, null, null);

                modal.startScroll();
                $('#image_list').css({
                    'opacity': '1',
                    'pointer-events': 'auto'
                });
                $('#photobox').css('top', '100vh');
                $('#photobox').css('opacity', '0');
            } else {
                history.back();
            }
        }
    });
    /////////////////////////////////////////////////

});

// 監視系
$(function () {

    // スライドの数が変わったら
    swiper.on('slidesLengthChange', function () {
        
        // スライドの数とそのオフセットを再計算
        swiper.updateSlides();

        // モーダルにパラメーター挿入
        insertParam_for_Slide($('.image_container').eq(swiper.realIndex)); // swiper.realIndex　swiper.jsオブジェクト（indexが取得できる）

        // チェックボックスの同期へ
        syncCheckbox(swiper.realIndex); // swiper.jsオブジェクト（indexが取得できる）

        // セレクトチェック
        onChangeCheckbox();

        // サムネリスト内のパラメーターを更新
        updateThumParam();

        // オリジナルデータダウンロードボタン表示非表示
        originalDataDLbtnToggle();
        
    });

    // アクティブなスライドが変わったら
    swiper.on('slideChange', function () {

        /// モーダルにパラメーター挿入
        insertParam_for_Slide($('.image_container').eq(swiper.realIndex));// swiper.realIndex　swiper.jsオブジェクト（indexが取得できる）

        // チェックボックスの同期へ
        syncCheckbox(swiper.realIndex); // swiper.realIndex　swiper.jsオブジェクト（indexが取得できる）

        // 元画像がスライドより小さい場合はリンクを隠す
        //hideZoomLink(swiper.realIndex);
    });

    // 拡大表示
    /*
    mySmartPhoto.on('open', function () {
        setTimeout(function () {
            mySmartPhoto.zoomPhoto();
        }, 1000);
    });*/
});

// オリジナルデータダウンロードボタン表示非表示
function originalDataDLbtnToggle() {
    if ($('#image_list').find('.download_data').length === 0) {
        $('#downloadButton').hide();
    } else {
        $('#downloadButton').show();
    }
}

// サムネクリック時
export function onClick_image_box(elem) {

    // クリックされたスライドのindexを取得
    let this_index = $('.image_box').index($(elem));

    // チェックボックスの同期へ
    syncCheckbox(this_index);

    // モーダルにパラメーター挿入
    insertParam_for_Slide($('.image_container').eq(this_index));

    // スライドを指定の画像まで移動
    swiper.slideTo(this_index, 0, false);

    // スライドモーダルを開く
    setPhotobox_height();
    $('#photobox').css('opacity', '1');
    $('#photobox').css('top', '0px');
    $('#image_list').css({
        'opacity': '0',
        'pointer-events': 'none'
    });
    modal.stopScroll();

    // 元画像がスライドより小さい場合はクリックさせない
    //hideZoomLink(this_index);
}

/*
// 元画像がスライドより小さい場合はクリックさせない
function hideZoomLink(this_index) {

    // イメージオブジェクト作成（ズーム画像）
    let zoomImage_temp = new Image();

    zoomImage_temp.src = $('.swiper-slide').eq(this_index).find('.slide_img_link').eq(0).attr('href');
    
    // スライドの枠を取得
    let swiper_slide = $('.swiper-slide').eq(this_index);

    zoomImage_temp.onload = function () {
        
        if (swiper_slide.height() < zoomImage_temp.height || swiper_slide.width() < zoomImage_temp.width) {
            $('#disableClick').hide();
        } else {
            $('#disableClick').show();
        }
    };
}
*/
// スライドにパラメーター挿入
export function insertParam_for_Slide(elem) {
    
    // スライド番号を挿入
    $('#image_count').text(swiper.realIndex + 1);
    // スライド総数を挿入
    $('#image_count_total').text(swiper.slides.length);
    // ファイル名を挿入
    $('#original_filename').text($(elem).find('.original_filename').text());

    // オリジナルデータボタン表示非表示
    if ($(elem).find('.download_data').length === 0) {
        $('#downloadButton_one').hide();
    } else {
        $('#downloadButton_one').show();
    }
}

// サムネリスト内のパラメーターを更新
function updateThumParam() {

    // 連番を更新
    $('#image_list').find('.image_number').each(function (i) {
        $(this).text(i + 1);
    });
}

// チェックボックスの同期　スライド用
export function syncCheckbox(elem_index) {

    let myindex = elem_index;

    // checkboxのonChange処理が済むまで時間を稼ぐ
    setTimeout(function () {

        // セレクトをチェック
        if ($('input:checkbox[name="selectimg"]').eq(myindex).prop('checked')) {

            // スライドのチェックボックスの状態をチェック済みにする
            $('.checkbox_btn_photobox').addClass('checkbox_active');
        } else {

            // スライドのチェックボックスの状態を元に戻す
            $('.checkbox_btn_photobox').removeClass('checkbox_active');
        }
    }, 100);
}


//　写真削除（one）
function delImage_one(uuid_list) {

    $.ajax({
        type: 'POST',
        url: mypath + 'image/del',
        data: {
            'uuid_list': uuid_list
        },
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {

                if (res['flag']) {

                    // サムネイルから要素を取り除く
                    $('.image_container').eq(swiper.realIndex).remove();

                    // スワイパーから要素を取り除く
                    swiper.removeSlide(swiper.realIndex);

                    // 写真が０かどうか
                    if (($('.image_container')).length === 0) {
                        // リロード
                        location.reload();
                    } else {
                        // 写真枚数更新
                        totalCount.innerHTML = $('.image_container').length;
                    }

                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // リロード
                            location.reload();
                        }
                    });
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                //console.log(XMLHttpRequest);

                Swal.fire({
                    title: 'エラー',
                    text: '',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // リロード
                        location.reload();
                    }
                });
            });
}

// スマホで拡大を禁止
/*
$(function () {
    document.body.addEventListener("touchstart", function (e) {
        if (e.touches && e.touches.length > 1) {
            e.preventDefault();
        }
    }, { passive: false });
    document.body.addEventListener("touchmove", function (e) {
        if (e.touches && e.touches.length > 1) {
            e.preventDefault();
        }
    }, { passive: false });
});
*/